import React from 'react';
import { CountdownTimer } from './CountdownTimer';
const comparisonRows = [{
  without: '❌ Horas cada semana buscando ejercicios',
  with: '✅ Todo ya planificado'
}, {
  without: '❌ Entrenamientos improvisados',
  with: '✅ Sesiones listas para usar'
}, {
  without: '❌ Sin progresión',
  with: '✅ Progresión completa U8-U17'
}, {
  without: '❌ Jugadores poco involucrados',
  with: '✅ Jugadores más comprometidos'
}, {
  without: '❌ Sin estructura de temporada',
  with: '✅ Temporada organizada de principio a fin'
}];
const offer = {
  emoji: '🏆',
  title: '⚽ FÚTBOL LISTO 360',
  description: '6 Volúmenes + 5 Bonos',
  originalPrice: '$67 USD',
  price: '$22 USD',
  ctaText: '⚽ QUIERO FÚTBOL LISTO 360 AHORA',
  ctaHref: 'https://calcio-giovanile-pronto.impultienda.ar/checkout',
  savings: 'AHORRÁS $45'
};
export function FinalCTA() {
  return <section className="w-full bg-[#0A0A0A] py-20 px-4" data-id="element-39">
      <div className="max-w-2xl mx-auto" data-id="element-40">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white text-center mb-8 tracking-tight leading-tight" data-id="element-41">
          El próximo entrenamiento puedes seguir improvisando.{' '}
          <br className="hidden md:block" data-id="element-42" />
          <span className="text-[#00A650]" data-id="element-43">
            O puedes entrar al campo con todo listo.
          </span>
        </h2>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-white font-bold text-sm sm:text-base mb-12 uppercase tracking-wider" data-id="element-44">
          <span data-id="element-45">Fútbol Listo 360.</span>
          <span className="text-[#333]" data-id="element-46">/</span>
          <span data-id="element-47">Todo planificado.</span>
          <span className="text-[#333]" data-id="element-48">/</span>
          <span data-id="element-49">Todo organizado.</span>
          <span className="text-[#333]" data-id="element-50">/</span>
          <span className="text-[#00A650]" data-id="element-51">Todo listo.</span>
        </div>

        <div className="bg-[#16161F] border border-[#00A65033] rounded-2xl overflow-hidden mb-12 shadow-2xl" data-id="element-52">
          <div className="grid grid-cols-2 bg-[#0A0A0A] border-b border-[#00A65033]" data-id="element-53">
            <div className="px-4 py-4 font-black text-[#B0B0C0] text-xs sm:text-sm text-center uppercase tracking-wider" data-id="element-54">
              Sin Fútbol Listo 360
            </div>
            <div className="px-4 py-4 font-black text-[#00A650] text-xs sm:text-sm text-center border-l border-[#00A65033] uppercase tracking-wider" data-id="element-55">
              Con Fútbol Listo 360
            </div>
          </div>
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-[#00A65033]' : ''}`} data-id="element-56">
              <div className="px-4 py-4 text-[#B0B0C0] text-xs sm:text-sm font-medium" data-id="element-57">
                {row.without}
              </div>
              <div className="px-4 py-4 text-white font-bold text-xs sm:text-sm bg-[#00A650]/5 border-l border-[#00A65033]" data-id="element-58">
                {row.with}
              </div>
            </div>)}
        </div>

        <div className="text-center mb-8" data-id="element-59">
          <CountdownTimer size="md" blinking={true} data-id="element-60" />
        </div>

        <div className="max-w-xl mx-auto mb-8" data-id="element-61">
          <div className="relative bg-[#16161F] border-2 border-[#00A650] rounded-2xl p-6 shadow-[0_0_40px_rgba(0,166,80,0.15)] overflow-hidden" data-id="element-62">
            <div className="absolute top-0 right-0 bg-[#00A650] text-white text-[10px] font-black px-3 py-1 rounded-bl-xl uppercase tracking-wider" data-id="element-63">
              🏆 KIT ESTRATÉGICO
            </div>

            <div className="flex items-center gap-2 mb-2 mt-3 sm:mt-0" data-id="element-64">
              <span className="text-xl" data-id="element-65">{offer.emoji}</span>
              <span className="text-white font-black text-base sm:text-lg tracking-tight" data-id="element-66">
                {offer.title}
              </span>
            </div>
            <p className="text-[#B0B0C0] text-sm font-medium mb-5" data-id="element-67">
              {offer.description}
            </p>

            <div className="flex items-end justify-between" data-id="element-68">
              <div data-id="element-69">
                <div className="text-[#B0B0C0] line-through text-sm font-bold mb-1" data-id="element-70">
                  {offer.originalPrice}
                </div>
                <div className="font-black text-4xl sm:text-5xl text-white tracking-tighter leading-none" data-id="element-71">
                  {offer.price}
                </div>
              </div>
              <span className="inline-block bg-[#00A650]/15 text-[#00A650] text-xs font-black px-3 py-1.5 rounded-full uppercase tracking-wider" data-id="element-72">
                {offer.savings}
              </span>
            </div>
          </div>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-73">
          <a href={offer.ctaHref} className="btn-cta-green block w-full text-center font-black text-lg sm:text-2xl py-6 rounded-2xl transition-colors shadow-2xl mb-6" data-id="element-74">
            {offer.ctaText}
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-[#B0B0C0] font-bold" data-id="element-75">
            <span className="flex items-center gap-1.5" data-id="element-76">🔒 Pago Seguro</span>
            <span className="flex items-center gap-1.5" data-id="element-77">
              ⚡ Acceso Inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-78">
              🛡️ Garantía 7 Días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-79">
              💳 Tarjeta · PayPal
            </span>
          </div>
        </div>
      </div>
    </section>;
}